import { OptimizedPrismicImage } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import styles from './index.module.scss';

export type PartnerConsumersProps =
  SliceComponentProps<Content.PartnerConsumersSlice>;

const PartnerConsumers = ({ slice }: PartnerConsumersProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
    >
      <div className={styles.title}>{slice.primary.title}</div>
      <article className={styles.logosWrapper}>
        {[0, 1].map((el) => (
          <div key={el} className={styles.logos}>
            {slice.primary.consumers.map((img, index) => (
              <OptimizedPrismicImage
                key={index}
                className={`${styles.logo} ${index === 0 && styles.bestCompanyLogo} ${index === 5 && styles.bbbLogo}`}
                field={img.logo}
              />
            ))}
          </div>
        ))}
      </article>
      {slice.primary.subtitle && (
        <p className={styles.subtitle}>{slice.primary.subtitle}</p>
      )}
    </section>
  );
};

export default PartnerConsumers;
